import { render, staticRenderFns } from "./TravelTypeForm.vue?vue&type=template&id=13172c55&scoped=true&"
import script from "./TravelTypeForm.vue?vue&type=script&lang=js&"
export * from "./TravelTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13172c55",
  null
  
)

export default component.exports